import type { OvpApiResult } from '@bldsoft/cappie/api/ovp'
import type { CallInit } from '@bldsoft/cappie/rest'
import type { InitHeaders } from '@bldsoft/cappie/transport/http'

export function toCallInitHeaders(
  headers: Record<string, string> | undefined
): InitHeaders | undefined {
  if (!headers || Object.keys(headers).length === 0) {
    return undefined
  }

  return headers
}

export function callInitFromParams(params?: {
  headers?: Record<string, string>
}): CallInit | undefined {
  const headers = toCallInitHeaders(params?.headers)
  return headers ? { headers } : undefined
}

export function throwOvpTransportError(result: OvpApiResult<unknown>): never {
  switch (result.kind) {
    case 'api-error':
      throw result.body
    case 'http-error':
      throw new Error(`HTTP ${result.http.status}`)
    case 'timeout':
      throw new Error(result.message || 'Request timeout')
    case 'validation':
      throw new Error(`OVP validation failed (${result.phase})`)
    case 'abort':
    case 'drop':
      throw new Error(result.message || 'Request cancelled')
    default:
      throw new Error(result.message || 'Request failed')
  }
}
